import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full px-4 md:px-6 lg:px-12 py-12 md:py-16 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">频道导航</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {indexData.map((item) => (
            <a
              key={item.id}
              href={`#${item.title}`}
              className="group flex items-center gap-3 bg-background-100 rounded-lg border border-background-200/70 p-4 cursor-pointer transition-all hover:border-primary-200/60 hover:bg-background-50"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-sm font-medium text-foreground-800 block whitespace-nowrap overflow-hidden text-ellipsis">{item.title}</span>
                <span className="text-xs text-foreground-400">{item.count}条内容</span>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}